export default __webpack_public_path__ + "static/media/standard_10.7c8e93d8.png";